import graphql__96daac2393fb9559ff06 from "./__generated__/DeletePaymentMethodDialog_paymentMethod.graphql.ts";
import graphql__80196dafa70fb759d5db from "./__generated__/DeletePaymentMethodDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeletePaymentMethodDialogProps = {
    paymentMethod: any,
    handleCloseDialog: () => {}
}

const DeletePaymentMethodDialog: React.FC<DeletePaymentMethodDialogProps> = (props) => {

    const intl = useIntl();
    const paymentMethod = useFragment(
        graphql__96daac2393fb9559ff06,
        props.paymentMethod
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__80196dafa70fb759d5db,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeletePaymentMethod'})
            }
        )
    }

    const initialValues = {
        id: paymentMethod.id
    }

    let paymentMethodType;
    switch (paymentMethod.paymentMethodType) {
        case 'Card': {
            switch (paymentMethod.cardBrand) {
                case 'Visa':
                    paymentMethodType = 'Visa credit card';
                    break;
                case 'Mastercard':
                    paymentMethodType = 'Mastercard credit card';
                    break;
                default:
                    paymentMethodType = 'credit card';
                    break;
            }
            break;
        }
        case 'SepaDebit': {
            paymentMethodType = 'SEPA direct debit';
            break;
        }
        case 'OnAccount': {
            paymentMethodType = 'payment method on account';
            break;
        }
        default: {
            paymentMethodType = 'unknown payment method';
        }
    }

    const paymentMethodDisplay = paymentMethodType + (paymentMethod.lastFourDigits ? " ending with " + paymentMethod.lastFourDigits : "");

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeletePaymentMethodDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeletePaymentMethodDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeletePaymentMethodDialog.confirmMessage'}, {type: paymentMethodDisplay})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeletePaymentMethodDialog;
